import { queryOptions, useQuery } from '@tanstack/react-query';
import { getVendorShopProducts } from '@/services/matching.service';

export function productListQueryOptions(params: {
    vendorId: string;
    tab?: string;
    keyword?: string;
    minPrice?: number;
    maxPrice?: number;
    page?: number;
    limit?: number;
}) {
    return queryOptions({
        queryKey: ['products', params],
        queryFn: () => getVendorShopProducts({ ...params, page: params.page ?? 1, limit: params.limit ?? 20 }),
        staleTime: 2 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        enabled: !!params.vendorId,
    });
}

export function useProductList(params: {
    vendorId: string;
    tab?: string;
    keyword?: string;
    minPrice?: number;
    maxPrice?: number;
    page?: number;
    limit?: number;
}) {
    const { data, isLoading, isError, error } = useQuery(productListQueryOptions(params));

    return {
        productList: data ?? null,
        isLoading,
        isError,
        error,
    };
}
